import { createSlice } from "@reduxjs/toolkit";
import { api } from "service/api";
import { FloorApi } from "service/apiVariables";
import { Toast } from "service/toast";
import { setLoader } from "./loader";
import { addQuery } from "helpers/utis";

export const floorSlice = createSlice({
  name: "floor",
  initialState: {
    floors: null,
    isLoading: false,
    floorData: {},
    activeFloor: null,
    inactiveFloor: null,
  },
  reducers: {
    saveFloorsList: (state, action) => {
      state.floors = action.payload || [];
      state.isLoading = false;
    },

    saveFloorData: (state, action) => {
      state.floorData = action.payload || null;
      state.isLoading = false;
    },

    setSelectedActiveFloor: (state, action) => {
      state.activeFloor = action.payload;
    },

    setSelectedInactiveFloor: (state, action) => {
      state.inactiveFloor = action.payload;
    },
  },
});

// same list api, just send type: active / inactive
export const getFloorListAct = (query) => (dispatch) => {
  FloorApi.getFloorListApi.addQuery = query;
  addQuery(query || {}, FloorApi.getFloorListApi);

  dispatch(setLoader(true));

  return new Promise((resolve, reject) => {
    api({ ...FloorApi.getFloorListApi })
      .then(({ data }) => {
        dispatch(saveFloorsList(data));
        dispatch(setLoader(false));
        resolve(data);
      })
      .catch((err) => {
        if (err?.status === 400) {
          dispatch(saveFloorsList(err?.data));
          dispatch(setLoader(false));
          resolve(err?.data);
        } else {
          dispatch(setLoader(false));
          reject(Toast({ type: "error", message: err?.message }));
        }
      });
  });
};

export const getFloorByIdAct = (id) => (dispatch) => {
  dispatch(setLoader(true));

  const baseConfig = FloorApi.getFloorByIdApi;
  const apiConfig = {
    method: baseConfig.method,
    baseURL: baseConfig.baseURL,
    api: baseConfig.api(id),
  };

  return new Promise((resolve, reject) => {
    api(apiConfig)
      .then((data) => {
        dispatch(saveFloorData(data?.data));
        dispatch(setLoader(false));
        resolve(data?.data);
      })
      .catch(({ message }) => {
        dispatch(setLoader(false));
        reject(Toast({ type: "error", message }));
      });
  });
};

// add floor
export const createFloorAct = (body) => () => {
  return new Promise((resolve, reject) => {
    api({ ...FloorApi.createFloorApi, body })
      .then((data) => {
        Toast({
          type: "success",
          message: data?.message || "Floor added successfully",
        });
        resolve(data);
      })
      .catch(({ message }) => reject(Toast({ type: "error", message })));
  });
};

// update floor
export const updateFloorAct = (id, body) => () => {
  const baseConfig = FloorApi.updateFloorApi;
  const apiConfig = {
    method: baseConfig.method,
    baseURL: baseConfig.baseURL,
    api: baseConfig.api(id),
    body,
  };

  return new Promise((resolve, reject) => {
    api(apiConfig)
      .then((data) => {
        Toast({
          type: "success",
          message: data?.message || "Floor updated successfully",
        });
        resolve(data);
      })
      .catch(({ message }) => reject(Toast({ type: "error", message })));
  });
};

// active -> inactive OR delete based on backend behavior
export const deleteFloorAct = (id) => () => {
  const baseConfig = FloorApi.deleteFloorApi;
  const apiConfig = {
    method: baseConfig.method,
    baseURL: baseConfig.baseURL,
    api: baseConfig.api(id),
  };

  return new Promise((resolve, reject) => {
    api(apiConfig)
      .then((data) => {
        Toast({
          type: "success",
          message: data?.message || "Floor deleted successfully",
        });
        resolve(data);
      })
      .catch(({ message }) => reject(Toast({ type: "error", message })));
  });
};

// inactive -> active
export const activateFloorAct = (id, status) => () => {
  const baseConfig = FloorApi.changeFloorStatusApi;
  const apiConfig = {
    method: baseConfig.method,
    baseURL: baseConfig.baseURL,
    api: baseConfig.api(id, status),
  };

  return new Promise((resolve, reject) => {
    api(apiConfig)
      .then((data) => {
        Toast({
          type: "success",
          message:
            data?.message ||
            `Floor ${status === "active" ? "activated" : "inactivated"} successfully`,
        });
        resolve(data);
      })
      .catch(({ message }) => reject(Toast({ type: "error", message })));
  });
};

export const {
  saveFloorsList,
  saveFloorData,
  setSelectedActiveFloor,
  setSelectedInactiveFloor,
} = floorSlice.actions;

export default floorSlice.reducer;
